import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { useState } from "react";
import { getAdjustmentReasonList } from "services/data.internal.service";
import { SelectField,SwitchField } from "ui-components/Form";

import { FormTitle, Text, DatePickerField } from "ui-components/Form";

function AdjustmentInfo({ formRender, control, errors, customerCode, setValue }) {
  const [reasonCodeOptions, setReasonCodeOptions] = useState([]);
  const [warehouseCodeOptions, setWarehouseCodeOptions] = useState([]);

  useQuery({
    queryKey: ["adjustment-reason-list"],
    queryFn: () => getAdjustmentReasonList({ active: true }),
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const options = data.data.data.map((x) => {
        return { label: `${x.reasonCode}` + (x.description1 ? ` - ${x.description1}` : ``), value: x.reasonCode };
      });
      setReasonCodeOptions(options);
    },
  });

  useCustWhOptionsQuery({
    customerCode,
    onSuccess: (data) => {
      setWarehouseCodeOptions(data.data.data);
      if (data.data.data) setValue("warehouseCode", data.data.data[0]);
    },
  });

  const onReasonChange = (e, option) => {
    setValue("reasonCode", option.value)
  }

  function renderFn(property, index, length) {
    const { xs, disabled, edit, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
    };

    let renderField;
    if (data.type === "text" || data.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (data.type === "date") {
      renderField = <DatePickerField field={fieldProps} />;
    } else if (data.type === "switch") {
      renderField = <SwitchField field={fieldProps} />;
    } else if (data.type === "select") {
      renderField = (
        <SelectField
          field={fieldProps}
          options={
            (data.name === "reasonCode" && reasonCodeOptions) ||
            (data.name === "warehouseCode" && warehouseCodeOptions)
          }
          onChange={(data.name === "reasonCode" && onReasonChange) || (data.name === "warehouseCode" && null)}
          control={control}
          errors={errors}
        />
      );
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title={"Add Adjustment"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default AdjustmentInfo;
